import { Navigate } from "react-router-dom";
import { withServiceRequestsGuard } from "../withInvestorPortalGuard";

/**
 * Unified "All Requests" hub — Real Estate is the only service-request workflow.
 */
function ServiceRequestsListPage() {
  return <Navigate to="/super_admin/investor_portal/requests/real-estate" replace />;
}

export default withServiceRequestsGuard(ServiceRequestsListPage);
